import { render, staticRenderFns } from "./CriminalRecordEntryDashboard.vue?vue&type=template&id=48edf6fb&"
import script from "./CriminalRecordEntryDashboard.vue?vue&type=script&lang=js&"
export * from "./CriminalRecordEntryDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports